<template>
  <div class="position-relative" id="subheader">
    <b-container>
      <b-row align-v="center" no-gutters>
        <b-col cols="12" class="position-static d-flex align-items-center justify-content-between">
          <!-- Logo -->
          <a :href="`${baseUrl}`" target="_blank" class="d-block ">
            <div class="py-3 h-100">
              <img :src="require('@/assets/img/logo/logo-coe.svg')" alt="kle" class="img img-fluid logo-header" />
            </div>
          </a>
          <!-- /Logo -->
          <div class="page-header-buttons">
            <ul>
              <li>
                <button type="button" aria-label="Hilfe" id="btn-help" class="page-header-button">
                  <span>Hilfe</span>
                  <b-icon icon="person" aria-hidden="true"></b-icon>
                </button>
                <b-popover
                  target="btn-help"
                  triggers="click blur"
                  placement="bottomleft"
                  custom-class="help-popover"
                >
                  <div class="help-popover-content">
                    <h4>Hilfe</h4>

                    <h5>Leichte Sprache</h5>
                    <p>
                      Wir stellen Inhalte unserer Web-Seite in Leichter Sprache zur Verfugung.
                      Das Angebot wird mit Hilfe Kunstlicher Intelligenz weiter ausgebaut.
                    </p>
                    <a :href="`${baseUrl}/leichte-sprache`" target="_blank" rel="noopener noreferrer" class="help-popover-link">
                      <span class="help-popover-link-dot"></span>
                      Leichte Sprache
                    </a>

                    <h5>Gebardensprache</h5>
                    <p>
                      Auf der folgenden Seite stellen wir Informationen in Deutscher Gebardensprache bereit,
                      die mit Hilfe Kunstlicher Intelligenz ubersetzt wurden.
                    </p>
                    <a :href="`${baseUrl}/gebaerdensprache`" target="_blank" rel="noopener noreferrer" class="help-popover-link">
                      <span class="help-popover-link-dot"></span>
                      Gebardensprache
                    </a>
                  </div>
                </b-popover>
              </li>
              <li>
                <button type="button" aria-label="Kontakt" id="btn-contact" class="page-header-button">
                  <span>Kontakt</span>
                  <b-icon icon="chat-square" aria-hidden="true"></b-icon>
                </button>
                <b-popover
                  target="btn-contact"
                  triggers="click blur"
                  placement="bottomleft"
                  custom-class="contact-popover"
                >
                  <div class="contact-popover-content">
                    <h4>Kontakt</h4>

                    <address>
                      Kreis Coesfeld - 50 - Soziales und Jobcenter<br>
                      Schutzenwall 18<br>
                      48653 Coesfeld
                    </address>

                    <address>
                      <span class="contact-row">
                        <b-icon icon="telephone-fill" aria-hidden="true"></b-icon>
                        02541 18-5800
                      </span>
                      <span class="contact-row">
                        <b-icon icon="printer-fill" aria-hidden="true"></b-icon>
                        02541 18-5899
                      </span>
                    </address>

                    <address>
                      <span class="contact-row">
                        <b-icon icon="envelope-fill" aria-hidden="true"></b-icon>
                        <a href="mailto:jobcenter@kreis-coesfeld.de">jobcenter@kreis-coesfeld.de</a>
                      </span>
                      <span class="contact-row">
                        <b-icon icon="pencil-fill" aria-hidden="true"></b-icon>
                        <a
                          href="https://formulare.kreis-coesfeld.de/metaform/Form-Solutions/sid/assistant/66d158d65fa44d6d02bafe64"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Kontaktformular
                        </a>
                      </span>
                    </address>
                  </div>
                </b-popover>
              </li>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

const KREIS_COESFELD_BASE_URL = 'https://www.kreis-coesfeld.de';

@Component({
  components: {},
})
export default class HeaderInformationNavigationCoe extends Vue {
  get baseUrl() {
    return KREIS_COESFELD_BASE_URL;
  }
}
</script>
<style scoped lang="scss">
[theme="default"] {
  #subheader {
    background-color: white !important;
  }
  .logo-header {
    width: 178px;
  }
  .auth-cabinet .logo-header {
    height: auto;
  }
}

.page-header-buttons {
  margin-left: auto;

  ul {
    list-style: none;
    display: flex;
    align-items: center;
    gap: 1.25rem;
    margin: 0;
    padding: 0;
  }
}

.page-header-button {
  display: flex;
  align-items: center;
  gap: .45rem;
  text-transform: uppercase;
  font-size: .72rem;
  font-weight: 700;
  letter-spacing: .02em;
  background: transparent;
  color: #111;
  border: none;
  padding: 0;

  svg {
    width: 1.55rem;
    height: 1.55rem;
  }
}

:deep(.help-popover) {
  max-width: 42rem;
  width: 42rem;
  border: 0;
  background: #ececec;
  border-radius: 0;
  padding: 1.1rem 1.25rem;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  .popover-body {
    padding: 0;
    color: #111;
  }
}

:deep(.help-popover .arrow) {
  display: block;
}

:deep(.contact-popover) {
  max-width: 27rem;
  width: 27rem;
  border: 0;
  background: #ececec;
  border-radius: 0;
  padding: 1.1rem 1.25rem;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);

  .popover-body {
    padding: 0;
    color: #111;
  }
}

:deep(.contact-popover .arrow) {
  display: block;
}

.help-popover-content {
  h3 {
    font-size: 3rem;
    font-weight: 700;
    margin: 0 0 .75rem;
    color: #4f7f9b;
  }

  h4 {
    font-size: 1.65rem;
    font-weight: 700;
    margin: 0 0 .35rem;
    color: #4f7f9b;
  }

  p {
    font-size: 1rem;
    line-height: 1.45;
    margin-bottom: .9rem;
    color: #111;
  }
}

.help-popover-link {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  margin: 0 0 1.35rem;
  border-radius: 999px;
  background: #f4f4f4;
  color: #111 !important;
  text-decoration: none !important;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.2;
  padding: .6rem .95rem;
}

.help-popover-link-dot {
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 50%;
  background: #5889a6;
  flex: 0 0 auto;
}

.contact-popover-content {
  h3 {
    font-size: 2.35rem;
    font-weight: 700;
    margin: 0 0 1rem;
    color: #111;
  }

  address {
    margin: 0 0 1rem;
    font-size: 1rem;
    line-height: 1.45;
    color: #111;
    font-style: normal;
  }

  a {
    color: #4f7f9b !important;
    text-decoration: underline !important;
  }
}

.contact-row {
  display: flex;
  align-items: center;
  gap: .7rem;
  margin-bottom: .4rem;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
